export const useMultiRefs = <T>(...refs: (React.Ref<T> | undefined)[]): React.RefCallback<T> => {
  return (element: T) => {
    for (const ref of refs) {
      if (!ref) {
        continue;
      }
      if (typeof ref === "function") {
        ref(element);
      } else {
        // biome-ignore lint/suspicious/noExplicitAny: To merge refs you need to override the readonly attribute
        (ref as React.MutableRefObject<any>).current = element;
      }
    }
  };
};
